function toCommaSeperatedList(array: string[]) {
	return array.reduce((prev, curr, index) => {
		if (prev == "") {
			return curr;
		} else {
			if (index == array.length - 1) {
				return `${prev} and ${curr}`;
			} else {
				return `${prev}, ${curr}`;
			}
		}
	}, "");
}

export { toCommaSeperatedList };
